import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/AlertDialog';
import { Button } from '@/components/ui/Button';
import { Loader2 } from 'lucide-react';

export interface CancelBookingConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  bookingCount: number;
  onConfirm: () => void | Promise<void>;
  loading?: boolean;
}

export function CancelBookingConfirmDialog({
  open,
  onOpenChange,
  bookingCount,
  onConfirm,
  loading = false,
}: CancelBookingConfirmDialogProps) {
  const multi = bookingCount > 1;

  return (
    <AlertDialog open={open} onOpenChange={(next) => !loading && onOpenChange(next)}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle>
            Cancel booking{multi ? 's' : ''}?
          </AlertDialogTitle>
          <AlertDialogDescription>
            {multi
              ? `Are you sure you want to cancel these ${bookingCount} session bookings? The student will be removed from those sessions.`
              : 'Are you sure you want to cancel this booking? The student will be removed from this enrollment.'}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel type="button" disabled={loading}>
            Keep booking{multi ? 's' : ''}
          </AlertDialogCancel>
          <Button
            type="button"
            variant="destructive"
            disabled={loading}
            onClick={() => void onConfirm()}
          >
            {loading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" aria-hidden />
                Cancelling…
              </>
            ) : (
              <>Cancel booking{multi ? 's' : ''}</>
            )}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
